import { registerIcons, setIconOptions } from '@fluentui/react';
export function initializeSvgIconSet(iconSet) {
    const { icons  } = iconSet;
    const subset = {
        // We need to pass an empty fontFace object so that Fluent applies the styles
        fontFace: {},
        style: {
            display: 'inline-block',
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none',
            '> svg': {
                fill: 'currentColor',
                height: '100%'
            }
        },
        icons
    };
    setIconOptions({
        disableWarnings: true
    });
    registerIcons(subset);
}
